import { useState, useEffect } from 'react'

// Inline styles can't be media-queried, so this hook lets components switch layout (e.g. collapse a
// label|value grid to a single column) below a breakpoint. Defaults to 560px (phones / very narrow windows).
export function useNarrow(bp = 560) {
  const [narrow, setNarrow] = useState(typeof window !== 'undefined' && window.innerWidth < bp)
  useEffect(() => {
    const on = () => setNarrow(window.innerWidth < bp)
    window.addEventListener('resize', on)
    return () => window.removeEventListener('resize', on)
  }, [bp])
  return narrow
}
